import { SYMBOL_HYPHEN } from '../../constants/common'

import {
  TableCellName,
  TableCellSorting,
  TableCellSortingParamValue,
} from './Table.enums'

export const TABLE_COLUMN_MAX_WIDTH = 1024 // px

export const TABLE_COLUMN_MIN_WIDTH = 150 // px

export const TABLE_COLUMN_MIN_WIDTH_SMALL = 56 // px

export const SCREEN_WIDTH_HIDE_TABLE_CONTROL_BAR_TEXT = 780 // px

export const TABLE_COLUMN_RESIZE_CONFIG_MAX_KEY = 'max'

export const TABLE_COLUMN_RESIZE_CONFIG_MIN_KEY = 'min'

export const TABLE_COLUMN_RESIZE_CONFIG_COMMON_KEY = 'common'

export const TABLE_COLUMN_RESIZE_CONFIG = {
  [TABLE_COLUMN_RESIZE_CONFIG_COMMON_KEY]: {
    [TABLE_COLUMN_RESIZE_CONFIG_MAX_KEY]: TABLE_COLUMN_MAX_WIDTH,
    [TABLE_COLUMN_RESIZE_CONFIG_MIN_KEY]: TABLE_COLUMN_MIN_WIDTH,
  },
}

export const TABLE_EMPTY_TEXT = SYMBOL_HYPHEN

export const TABLE_ROW_CHECKBOX_WIDTH = 58 // px

export const TABLE_DATE_CELL_NAMES = [
  TableCellName.ClosedAt,
  TableCellName.ConstructionYear,
  TableCellName.ContractEnd,
  TableCellName.ContractStart,
  TableCellName.Created,
  TableCellName.DueDate,
  TableCellName.LastInvited,
  TableCellName.Registered,
  TableCellName.Updated,
]

export const TABLE_NUMBER_CELL_NAMES = [
  TableCellName.AmountRestriction,
  TableCellName.Area,
  TableCellName.ConstructionYear,
  TableCellName.DoorNumber,
  TableCellName.Entrance,
  TableCellName.ExternalId,
  TableCellName.Flat,
  TableCellName.FlatCount,
  TableCellName.Floor,
  TableCellName.InhabitantCount,
  TableCellName.InsuranceContractNumber,
  TableCellName.ObjectNumber,
  TableCellName.ORAGNumberOwner,
  TableCellName.Phone,
  TableCellName.PostalCode,
  TableCellName.PropertyShare,
  TableCellName.RequestNo,
  TableCellName.RoomCount,
  TableCellName.Number,
]

export const TABLE_NUMBER_CELL_SORTING_OPTIONS = [
  {
    id: TableCellSorting.Asc,
    text: 'Table.SortingOptionAscendingNumberCellKey',
    value: TableCellSortingParamValue[TableCellSorting.Asc],
  },
  {
    id: TableCellSorting.Desc,
    text: 'Table.SortingOptionDescendingNumberCellKey',
    value: TableCellSortingParamValue[TableCellSorting.Desc],
  },
  {
    id: TableCellSorting.Reset,
    text: 'Table.SortingOptionResetKey',
    value: TableCellSortingParamValue[TableCellSorting.Reset],
  },
]

export const TABLE_TEXT_CELL_SORTING_OPTIONS = [
  {
    id: TableCellSorting.Asc,
    text: 'Table.SortingOptionAscendingTextCellKey',
    value: TableCellSortingParamValue[TableCellSorting.Asc],
  },
  {
    id: TableCellSorting.Desc,
    text: 'Table.SortingOptionDescendingTextCellKey',
    value: TableCellSortingParamValue[TableCellSorting.Desc],
  },
  {
    id: TableCellSorting.Reset,
    text: 'Table.SortingOptionResetKey',
    value: TableCellSortingParamValue[TableCellSorting.Reset],
  },
]

export const QA_NAME_TABLE_DEFAULT = 'table'

export const QA_NAME_TABLE_ROW_DEFAULT = 'table_row'
